// extracted by mini-css-extract-plugin
module.exports = {"header":"Movie_header__3Hh8M","movieWraper":"Movie_movieWraper__1Hdju","image":"Movie_image__2tmlA","infoWraper":"Movie_infoWraper__3WRcT","score":"Movie_score__240we"};